<!-- Saída animada: o AppComponent põe `animate.leave="ai-painel-sai"` no HOST <ai-painel>; enquanto
     a animação roda, o aside fica no DOM. `--ai-painel-largura-saida` é um snapshot da largura: a
     variável global `--ai-painel-largura` já vai a 0px no mesmo tick (AiLayoutService) e sem o
     snapshot o painel colapsaria em vez de deslizar. -->
<aside class="ai-painel" [style.--ai-accent]="accent"
       [style.--ai-painel-largura-saida.px]="layout.larguraEfetiva()"
       [class.is-arrastando]="!!layout.arrastando()" [class.is-vai-fechar]="!!layout.arrastando()?.vaiFechar"
       role="complementary" aria-label="Assistente One">
  <div class="ai-painel-pega" oneResize edge="left" [min]="MIN" [max]="MAX" [larguraAtual]="layout.larguraEfetiva()"
       [fechaAlem]="FECHA_ALEM" aria-label="Redimensionar assistente"
       (inicio)="layout.iniciarArrasto()" (movimento)="layout.moverArrasto($event)"
       (fim)="layout.terminarArrasto($event)" (cancelado)="layout.cancelarArrasto()"></div>
  <header class="ai-painel-top">
    <span class="ai-orb-mini" [attr.data-estado]="svc.estado()" aria-hidden="true"></span>
    <span class="ai-painel-estado">{{ rotuloEstado() }}</span>
    <div class="ai-top-actions">
      <one-icon-button size="sm" [icon]="svc.mutado() ? 'volume_off' : 'volume_up'" [active]="svc.mutado()"
                       [ariaLabel]="svc.mutado() ? 'Ativar som' : 'Silenciar'" (clicked)="alternarMudo()" />
      <one-icon-button size="sm" icon="view_sidebar" ariaLabel="Desacoplar" title="Desacoplar (cartão flutuante)"
                       data-test="painel-desacoplar" (clicked)="desacoplar()" />
      <one-icon-button size="sm" icon="open_in_full" ariaLabel="Tela cheia" title="Tela cheia"
                       data-test="painel-tela-cheia" (clicked)="telaCheia()" />
      <one-icon-button size="sm" icon="refresh" ariaLabel="Nova conversa" data-test="painel-nova" (clicked)="svc.novaConversa()" />
      <one-icon-button size="sm" icon="close" ariaLabel="Fechar" data-test="painel-fechar" (clicked)="svc.fechar()" />
    </div>
  </header>
  <div class="ai-painel-corpo">
    <ai-conversa [compacto]="true" />
  </div>
</aside>
